angular.module('bb.external').config(ExternalRoutes);

ExternalRoutes.$inject = ['$routeProvider'];
function ExternalRoutes($routeProvider) {
  $routeProvider
    // remove these!!!!
    .when('/dash/:dashboardId/status', {
      redirectTo: '/dash/:dashboardId/appointments',
    })
    .when('/dash/:dashboardId/status/:statuses', {
      redirectTo: '/dash/:dashboardId/appointments',
    })
    .when('/dash/:dashboardId/appointments/listing/:listingId', {
      template: '<bb-appointment-list-view/>',
    })
    .when('/dash/:dashboardId/appointments/:appointmentId?', {
      reloadOnSearch: false,
      template: '<bb-appointment-list-view/>',
    })
    .when('/dash/:dashboardId/buyer_appointments', {
      template: '<bb-external-buyer-contact-appointment-list/>',
    })
    .when('/dash/:dashboardId/buyer_contact_appointments', {
      template: '<bb-external-buyer-contact-appointment-list/>',
    })
    .when('/dash/:dashboardId/appointments/:appointmentId/status/:status', {
      reloadOnSearch: false,
      template: '<bb-external-appointment-cancel/>',
    })
    .when('/dash/:dashboardId/appointments/:appointmentId/feedback', {
      template: '<bb-external-feedback />',
    })
    .when('/dash/:dashboardId/listing/', {
      template: '<bb-external-listing/>',
    })
    .when('/dash/:dashboardId/listing/:listingId', {
      template: '<bb-external-listing />',
    })
    .when('/dash/:dashboardId/notifications', {
      template: '<bb-external-notification />',
    })
    .when('/dash/:dashboardId/book', {
      template: '<bb-external-book/>',
    })
    .when('/dash/:dashboardId/offers', {
      template: '<bb-external-offers/>',
    })
    .when('/dash/:dashboardId/my_agent', {
      template: '<bb-my-agent/>',
    })
    // RETS!!!
    .when('/rets/:retsId/appointments/offers', {
      template: '<bb-external-offers/>',
    })
    .when('/rets/:retsId/listing', {
      template: '<bb-external-listing/>',
    })
    .when('/dash/:dashboardId/updates', {
      template: '<bb-appointment-updates/>',
    })
    .when('/rets/:retsId/appointments/updates', {
      template: '<bb-appointment-updates/>',
    })
    .when('/rets/:retsId/appointments/book', {
      template: '<bb-external-book/>',
    })
    .when('/rets/:retsId/appointments/offer', {
      template: '<bb-external-offers/>',
    })
    .when('/dash/:dashboardId/appointments/:appointmentId/reschedule', {
      template: `<bb-external-appointment-time-change />`,
    })
    .when('/dash/:dashboardId/appointments/:appointmentId/reschedule_contact', {
      template: `<bb-external-appointment-time-change is-listing-contact="true" />`,
    })
    .when('/rets/:retsId/tour/:tourId/details', {
      template: `<bb-virtual-tour-details-external />`,
    })
    .when('/dash/:dashboardId/tour/:tourId/details', {
      template: `<bb-virtual-tour-details-external />`,
    });
}

export {};
